import React, {useContext} from 'react';
import {useSelector} from "react-redux";
import {useParams, useSearchParams} from 'react-router-dom';

import SimpleTable from "../../components/Common/Elements";

import { Card, CardContent, CardHeader, Grid, Stack, Typography } from "@mui/material"


import Loading from "../../components/Common/Loading";
import {useGetStateV2RTQuery} from "../../core/api/rogerthat-state-api";
import {paymentUserStatus} from "../../core/utils/constants";
import TechInfoRT from "../TechInfo/techInfoRT";
import {format} from "date-fns";
import {isEmpty} from "../../core/utils/StringUtils";
import {SnackBarContext} from "../../snackBarProvider";
import {Alert} from "@mui/material";
import UserSocialInfoRT from "../UserInfo/userSocialInfoRT";
import {stringify} from "lossless-json";
import {useGetStateV2DSQuery} from "../../core/api/ds-state-api";
import UserSocialInfoDS from "../UserInfo/userSocialInfoDS";
import TechInfoDS from "../TechInfo/techInfoDS";
import SpammerControl from "../BanControl/SpammerControl"
import StateCopyLogCard from "../../components/Common/StateCopyLogCard"


function DashboardDS() {

    const {deviceId: deviceIdParam} = useParams();
    const [searchParams] = useSearchParams();
    const deviceId = deviceIdParam ?? "";
    const stateId = searchParams.get('vendorId') ?? "";
    const deviceIdIsEmpty = !deviceId && !stateId;

    const {
        data: obj,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error
    } = useGetStateV2DSQuery({deviceId, stateId}, {skip: deviceIdIsEmpty})


    const getByName = (items = [], name) => items.find((item) => item.Name === name)?.Amount

    let panel1 = ""

    const useSnackBars = () => useContext(SnackBarContext);
    const {addAlert} = useSnackBars();

    if (typeof obj === "object" && obj.hasOwnProperty('data')) {

        const data = JSON.parse(obj.data)
        if((data.hasOwnProperty('userID') || data.hasOwnProperty('UserID'))) {
            let source = {
                account_info: [],
                progress_info: [],
                payment_info: [],
                ingame_goods: []
            }


            try {
                source = {
                    account_info: [
                        ["User ID", data.UserID],
                        ["User Seed", data.UserSeed],
                        ["Time spent", data.Timespend],
                        ["Timestamp", format(new Date(data.Timestamp * 1000), "dd.MM.yyyy HH:mm:ss")],
                        ["Save ID", data.SaveID],
                        ["Install version", data.InstallVersion],
                        ["Current version", data.CurrentVersion],
                        ["FB profile", data.Records.FacebookProfile?.Connected?.toString()]
                    ],
                    payment_info: [
                        ["Total payments", data.Records.PaymentProfile.PaymentSUM],
                        ["Segment", paymentUserStatus(data.Records.PaymentProfile?.PaymentSUM)],
                        ["Payment Count", data.Records?.PaymentProfile?.PaymentCNT],
                        ["Payment Date", data.Records?.PaymentProfile?.PaymentDate === undefined ? 'no data' : format(new Date(data.Records.PaymentProfile.PaymentDate * 1000), "dd.MM.yyyy HH:mm:ss")],
                        ["Payment Min", data.Records?.PaymentProfile?.PaymentLST],
                        ["Payment Max", data.Records?.PaymentProfile?.PaymentMAX],
                    ],
                    progress_info: [],
                    ingame_goods: []

                }
            } catch (e) {
                console.log(e)
                return <Alert severity={"error"}>Can't parse state</Alert>
            }


            panel1 = <>
                <Grid size={4}>
                    <Card>
                        <CardContent>
                            <Typography sx={{fontSize: 16}}>
                                Account Info
                            </Typography>
                        </CardContent>
                        <SimpleTable data={source.account_info}/>
                        <Stack direction="column" sx={{ p: 2, rowGap: 1 }}>
                            <SpammerControl userId={deviceId} project="ds" />
                        </Stack>
                    </Card>
                </Grid>
                <Grid size={4}>
                    <Card>
                        <CardContent>
                            <Typography sx={{fontSize: 16}}>
                                Payment Info
                            </Typography>
                        </CardContent>
                        <SimpleTable data={source.payment_info}/>
                    </Card>
                </Grid>
            </>
        }



    } else if (typeof obj === "object" && obj.data.hasOwnProperty('error')) {
        panel1 = obj.data.error
    } else {
        panel1 = 'unknown error'
    }

    return (
        <>
            <Loading
                isLoading={isLoading||isFetching}
                isError={isError}
                error={error}
            >
                <Grid container spacing={2}>
                    {panel1}
                    <Grid size={4}>
                        <TechInfoDS isSimple={true} deviceId={deviceId}/>
                    </Grid>
                    <Grid size={4}>
                        <UserSocialInfoDS deviceId={deviceId}/>
                    </Grid>
                    <Grid size={8}>
                        <StateCopyLogCard logs={obj?.copyLogs}/>
                    </Grid>
                </Grid>
            </Loading>
        </>
    );

}

export default DashboardDS
